import performSearchFilterAsync from '@Containers/ResultsFilters/performSearchFilterAsync';
import { preparePropertiesForRequest } from '@Containers/ResultsFilters/performSearchFilterAsync/preparePropertiesUtils';
import NewRelicService, { BROWSER_INTERACTIONS_NAMES } from '@Services/NewRelicService';
import {
  filters as filtersDataSelector,
  keyifyParamsForFiltersRequest,
  paramsForFiltersRequest as paramsForFiltersRequestSelector,
} from '@Containers/ResultsFilters/ResultsFiltersComponents/ListOfFilters/ListOfFiltersSelectors';
import {
  query as queryTextSelector,
  previewResults as previewResultsSelector,
} from '@Pages/QuickSearch/Components/QuickResults/QuickResultsSelectors';
import { withGlobalSpinnerActionEnhancer } from '@Utils/Redux/withGlobalSpinnerActionEnhancer';
import { clearFilterState } from '@Containers/ResultsFilters/ResultsFiltersComponents/ListOfFilters/ListOfFiltersActions';
import AppStorage from '@Services/AppStorage';
import assignIn from 'lodash/assignIn';

const getSemanticSearchValues = (state) => {
  const previewResults = previewResultsSelector(state) || [];
  const semanticCitationsResult = previewResults.find((item) => item.context === 'citations' && item.semanticSearchIncluded === true);

  if (!semanticCitationsResult) {
    return {};
  }

  return {
    textQuery: queryTextSelector(state),
    semanticSearchIncluded: semanticCitationsResult.semanticSearchIncluded,
    semanticResultName: semanticCitationsResult.semanticResultName,
  };
};

export const limitTo = withGlobalSpinnerActionEnhancer(() => async (dispatch, getState) => {
  try {
    const state = getState();
    const params = paramsForFiltersRequestSelector(state);
    let browserInteraction;
    if (params.context === 'substances') {
      browserInteraction = NewRelicService.createBrowserInteraction(BROWSER_INTERACTIONS_NAMES.TIME_TO_APPLY_FILTERS_TO_SUBSTANCES);
    }

    let baseParamsExtension;
    // retrieve semantic search values from quick results state
    if (params.context === 'citations') {
      baseParamsExtension = getSemanticSearchValues(state);
      Logger.info('Applying semantic search values to citations filter request (limitTo)', baseParamsExtension);
    }

    const filters = filtersDataSelector(state);
    const properties = preparePropertiesForRequest(filters, state);

    await performSearchFilterAsync({ filters, properties, browserInteraction, baseParamsExtension });

    AppStorage.instance.setToSessionStorage('integratedFeedbackHide', true);
  } catch (e) {
    Logger.error('filters on react: limit to exception', e);
  }
});

export const exclude = withGlobalSpinnerActionEnhancer(() => async (dispatch, getState) => {
  try {
    const state = getState();
    const filters = filtersDataSelector(state);
    const params = paramsForFiltersRequestSelector(state);
    const properties = preparePropertiesForRequest(filters, state);

    const baseParamsExtension = { exclude: true };
    // retrieve semantic search values from quick results state
    if (params.context === 'citations') {
      assignIn(baseParamsExtension, getSemanticSearchValues(state));
      Logger.info('Applying semantic search values to citations filter request (Exclude)', baseParamsExtension);
    }

    await performSearchFilterAsync({
      filters,
      properties,
      baseParamsExtension,
    });

    AppStorage.instance.setToSessionStorage('integratedFeedbackHide', true);
  } catch (e) {
    Logger.error('filters on react: exclude exception', e);
  }
});

export const clear = withGlobalSpinnerActionEnhancer(() => async (dispatch, getState) => {
  try {
    const state = getState();
    const key = keyifyParamsForFiltersRequest(state);

    const action = clearFilterState(key);
    dispatch(action);
  } catch (e) {
    Logger.error('filters on react: clear exception', e);
  }
});
